import React, { useEffect, useState } from "react";
import { ContentContainer } from "../../../components/layout";
import { DataTable } from "primereact/datatable";
import { useSelector } from "react-redux";
import TotalRecords from "../../../components/core/total-records";
import { Button, Modal, Table, Textfield } from "../../../components/core";
import { useMutation, useQuery } from "@apollo/client";
import {
	CREATE_USER_TYPE,
	UPDATE_USER_TYPE,
	USER_TYPES,
} from "../../../constants/graphql/locker-user-types";
import LockerUserTypeTable from "./component/locker-user-table";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { InputNumber } from "primereact/inputnumber";
import { Strings } from "../../../constants/strings";
import { Card } from "primereact/card";
import { Divider } from "primereact/divider";

const LockerUserType = () => {
	const operatorId = JSON.parse(localStorage.getItem("user")).operator_id;
	const accessPermission = useSelector(
		(state) => state.accessPermissions.accessPermissions
	);

	// local state
	const [userTypeTable, setUserTypeTable] = useState([]);
	const [openAddDialog, setAddOpenDialog] = useState(false);
	const [addUserVar, setAddUserVar] = useState({
		userType: "",
		description: "",
		monthlyFee: 0,
	});
	// Redux States
	const userTypeData = useSelector(
		(state) => state.lockerUserTypes.userTypeData
	);

	// Graphql
	const userTypes = useQuery(USER_TYPES, {
		variables: {
			operatorId: operatorId,
		},
	});
	const [updateLockerUserType] = useMutation(UPDATE_USER_TYPE);
	const [createLockerUserType] = useMutation(CREATE_USER_TYPE);

	// validation
	const [validation, setValidation] = useState({
		icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
		title: "",
		message: "",
		open: false,
	});

	const showError = (title, message) => {
		setValidation({
			icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
			title: title,
			message: message,
			open: true,
			actions: (
				<div className="w-full">
					<Button
						onClick={() => setValidation({ open: false })}
						value={"OK"}
						className={"p-2 w-full"}
					/>
				</div>
			),
		});
	};

	useEffect(() => {
		if (userTypes.data) {
			const lockerUserTypes = userTypes.data?.lockerUserTypes;

			setUserTypeTable(lockerUserTypes);
		}
	}, [userTypes.data]);

	const validateFields = () => {
		if (!addUserVar.userType || !addUserVar.description) {
			showError(
				Strings.popup_error_title,
				Strings.popup_error_title_empty_field
			);
			return;
		}

		if (addUserVar.monthlyFee === 0) {
			showError(
				Strings.popup_error_title,
				"Monetary values cannot be equal to 0"
			);
			return;
		} else {
			addData();
		}
	};

	const addData = () => {
		let monthlyFee = addUserVar.monthlyFee;

		// Convert to number and fix decimal if necessary
		if (!monthlyFee.includes(".")) {
			console.log("hello");
			// monthlyFee = parseFloat(monthlyFee); // Convert to float (int if no decimals)
			monthlyFee = Math.round(monthlyFee * 100) / 100;
		} else {
			monthlyFee = Math.round(monthlyFee * 100) / 100;
		}
		console.log({ MONTHLY_FEE: monthlyFee });

		// parse the string back to number before passing it to the variables
		// monthlyFee = parseFloat(monthlyFee);

		createLockerUserType({
			variables: {
				operatorId: operatorId,
				userType: addUserVar.userType,
				description: addUserVar.description,
				monthlyFee: monthlyFee,
				sort: 1,
			},
		})
			.then((response) => {
				if (response) {
					setValidation({
						icon: `${process.env.PUBLIC_URL}/assets/images/check.png`,
						message: Strings.popup_success_message_add,
						open: true,
						actions: (
							<div className="grid grid-cols-1">
								<Button
									onClick={() => {
										setValidation({ open: false });
										window.location.reload();
									}}
									value={"OK"}
									className={"p-2"}
								/>
							</div>
						),
					});
				}
			})
			.catch((error) => {
				if (
					error.message.includes(
						"duplicate key value violates unique constraint"
					)
				) {
					showError(
						Strings.popup_error_title,
						Strings.popup_error_message_duplicate
					);
					return;
				}
			});
	};

	console.log({ addUserVar });
	return (
		<ContentContainer containerTitle={"Locker User Types"}>
			{/* <DataTable value={userTypeData}></DataTable> */}
			{accessPermission.lockerUserType === 1 ||
			accessPermission.lockerUserType === "1" ? (
				<>
					<div className="pt-6">
						<Card className="">
							<TotalRecords count={userTypeTable.length} />
							<Table
								headers={[
									{
										header_key: "userType",
										header_name: "Locker User Type",
									},
									{ header_key: "description", header_name: "Description" },
									{ header_key: "monthlyFee", header_name: "Monthly Fee" },
								]}
								items={userTypeTable}
							/>
						</Card>
					</div>
				</>
			) : (
				<>
					<Button
						value={"Add Locker User Type"}
						className={"p-2 my-4 mx-0 "}
						// onClick={handleOnAddUserType}
						onClick={() => {
							setAddOpenDialog(true);
						}}
						disabled={
							accessPermission.lockerUserType === 1 ||
							accessPermission.lockerUserType === "1"
						}
					/>
					<TotalRecords count={userTypeTable.length} />
					<LockerUserTypeTable
						userTypeData={userTypeTable}
						accessPermission={accessPermission}
						operatorId={operatorId}
					/>
				</>
			)}

			<Dialog
				visible={openAddDialog}
				onHide={() => {
					setAddOpenDialog(false);
					setAddUserVar({
						...addUserVar,
						userType: "",
						description: "",
						monthlyFee: "",
					});
				}}
				header="Add Locker User Type"
				className="w-[450px]"
				draggable={false}
				resizable={false}
			>
				<div>
					<div className="grid w-full grid-cols-8 space-y-4">
						<div className="col-span-8 text-md font-semibold">
							User Type Information
						</div>
						<div className="col-span-8 ">
							<div className="grid grid-cols-5 space-y-2">
								<div className="col-span-5">
									<span className="text-red-500">* </span>Locker User Type
								</div>
								{/* <div className="col-span-8"> */}
								<InputText
									value={addUserVar.userType}
									className="col-span-5"
									maxLength={32}
									pt={{
										root: {
											className: "border border-gray-200 p-1 h-10 rounded-md",
										},
									}}
									onChange={(e) => {
										setAddUserVar({
											...addUserVar,
											userType: e.target.value,
										});
									}}
								/>
							</div>
						</div>
						{/* ---------------------------------------------- */}
						<div className="col-span-8 ">
							<div className="grid grid-cols-5 space-y-2">
								<div className="col-span-5">
									<span className="text-red-500">* </span>Description
								</div>
								{/* <div className="col-span-8"> */}
								<InputTextarea
									value={addUserVar.description}
									style={{
										overflowY: "auto",
									}}
									className="col-span-5 max-h-[200px]"
									maxLength={1000}
									rows={4}
									autoResize
									pt={{
										root: {
											className: "border border-gray-200 p-1 rounded-md",
										},
									}}
									onChange={(e) => {
										setAddUserVar({
											...addUserVar,
											description: e.target.value,
										});
									}}
								/>
							</div>
							<p className="text-end">
								{addUserVar?.description?.length}/{1000}
							</p>
						</div>
						{/* ------------------------------------------------------ */}
						<div className="col-span-8 ">
							<Divider className=" border border-gray-200 "></Divider>
						</div>

						<>
							<div className="col-span-8 text-md font-semibold">
								Fees Related
							</div>
							<div className="col-span-8">
								<div className="grid grid-cols-5  space-y-2">
									<div className="col-span-5">
										<span className="text-red-500">* </span>Monthly Fee
									</div>
									{/* <div className="col-span-8"> */}
									{/* <InputNumber
									// inputId="currency-ph"
									// mode="currency"
									// currency="PHP"
									prefix="₱"
									locale="en-US"
									useGrouping={true}
									maxLength={10}
									// minFractionDigits={2}
									// maxFractionDigits={2}
									value={addUserVar.monthlyFee}
									className="col-span-5"
									pt={{
										root: {
											className: "border border-gray-200 p-1 rounded-md",
										},
									}}
									onValueChange={(e) => {
										setAddUserVar({
											...addUserVar,
											monthlyFee: e.target.value,
										});
									}}
								/> */}
									<div className="relative col-span-5 flex items-center ">
										{/* <span
										className={`absolute top-1/2 transform -translate-y-1/2 left-3 text-gray-500 z-10`}
									>
										P
									</span> */}
										{/* <Textfield
										type={"int"}
										// maxLength={13}
										placeholder="00.00"
										value={addUserVar.monthlyFee}
										prefix={"₱"}
										classNameParent={"w-full"}
										// classNameParent="col-span-5"
										onChange={(e) => {
											console.log("here");

											// let inputValue = e.target.value;
											// var numberPattern = /^(\d+(\.\d{0,2})?|\.\d{0,2})?$/;
											let regex = /^(\d+(\.\d{0,2})?|\.\d{0,2})?$/;

											if (
												(regex.test(e.target.value) &&
													parseFloat(e.target.value) <= 1000000000) ||
												e.target.value === ""
											) {
												setAddUserVar({
													...addUserVar,
													monthlyFee: e.target.value,
												});
											}
										}}
									/> */}
										<Textfield
											type="text"
											placeholder="00.00"
											value={addUserVar.monthlyFee}
											prefix="₱"
											classNameParent="w-full"
											onChange={(e) => {
												// let value = e.target.value;

												// // Remove non-numeric except dot
												// value = value.replace(/[^0-9.]/g, "");

												// // Prevent multiple dots
												// if ((value.match(/\./g) || []).length > 1) {
												// 	return;
												// }

												// // Remove leading zeros (except 0 before a decimal point)
												// if (
												// 	value.startsWith("0") &&
												// 	value.length > 1 &&
												// 	!value.startsWith("0.")
												// ) {
												// 	value = value.replace(/^0+/, "");
												// }

												// // Ensure at least `.00` when a valid number is typed
												// if (value !== "" && !value.includes(".")) {
												// 	value = value + ".00"; // Autofloat format
												// }

												// // Limit decimal places to 2
												// let parts = value.split(".");
												// if (parts.length === 2 && parts[1].length > 2) {
												// 	parts[1] = parts[1].substring(0, 2);
												// 	value = parts.join(".");
												// }

												// // Limit maximum value
												// if (parseFloat(value) > 1000000000) {
												// 	return;
												// }

												// setAddUserVar({
												// 	...addUserVar,
												// 	monthlyFee: value,
												// });

												let inputValue = e.target.value;
												var numberPattern = /^(\d+(\.\d{0,2})?|\.\d{0,2})?$/;

												if (
													(numberPattern.test(inputValue) &&
														parseFloat(inputValue) <= 1000000000) ||
													inputValue === ""
												) {
													setAddUserVar({
														...addUserVar,
														monthlyFee: inputValue,
													});
												}
											}}
										/>
									</div>
								</div>
							</div>
							{/* should be percentage? */}
							<div className="col-span-8">
								<div className="grid grid-cols-5  space-y-2">
									<div className="col-span-5">
										<span className="text-red-500">* </span>Payment Collection
										Fee
									</div>

									<div className="relative col-span-5 flex items-center ">
										<Textfield
											type="text"
											placeholder="00.00"
											value={addUserVar.monthlyFee}
											prefix="₱"
											classNameParent="w-full"
											onChange={(e) => {
												let inputValue = e.target.value;
												var numberPattern = /^(\d+(\.\d{0,2})?|\.\d{0,2})?$/;

												if (
													(numberPattern.test(inputValue) &&
														parseFloat(inputValue) <= 1000000000) ||
													inputValue === ""
												) {
													setAddUserVar({
														...addUserVar,
														monthlyFee: inputValue,
													});
												}
											}}
										/>
									</div>
								</div>
							</div>
							{/* should be percentage? */}
							<div className="col-span-8">
								<div className="grid grid-cols-5  space-y-2">
									<div className="col-span-5">
										<span className="text-red-500">* </span>Internal Bank
										Transfer Fee
									</div>

									<div className="relative col-span-5 flex items-center ">
										<Textfield
											type="text"
											placeholder="00.00"
											value={addUserVar.monthlyFee}
											prefix="₱"
											classNameParent="w-full"
											onChange={(e) => {
												let inputValue = e.target.value;
												var numberPattern = /^(\d+(\.\d{0,2})?|\.\d{0,2})?$/;

												if (
													(numberPattern.test(inputValue) &&
														parseFloat(inputValue) <= 1000000000) ||
													inputValue === ""
												) {
													setAddUserVar({
														...addUserVar,
														monthlyFee: inputValue,
													});
												}
											}}
										/>
									</div>
								</div>
							</div>
						</>
						{/* </div> */}
					</div>

					<div className="pt-6">
						<Button
							value={"Save changes"}
							className={"p-2 mx-auto"}
							onClick={validateFields}
							disabled={
								accessPermission.lockerUserType === 1 ||
								accessPermission.lockerUserType === "1"
							}
						/>
					</div>
				</div>
			</Dialog>

			<Modal
				icon={validation.icon}
				title={validation.title}
				message={validation.message}
				open={validation.open}
				actions={validation.actions}
			/>
		</ContentContainer>
	);
};

export default LockerUserType;
